'use client';
import styled from 'styled-components';

export const StepHeaderContent = styled.div`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing(5.5)};
`;

export const StepTitle = styled.h1`
  ${({ theme }) => theme.typography.heading2}
  margin-bottom: ${({ theme }) => theme.spacing(1.5)};

  @media ${({ theme }) => theme.tabletL} {
    ${({ theme }) => theme.typography.heading1}
  }

  letter-spacing: 0.02rem;
`;

export const StepDescription = styled.p`
  ${({ theme }) => theme.typography.body}
  color: ${({ theme }) => theme.colors.text.secondary}
`;

export const StyledDesktopImage = styled.div`
  display: none;
  @media ${({ theme }) => theme.tabletL} {
    display: inline-block;
    margin-top: ${({ theme }) => theme.spacing(6)};
  }
`;
export const StyledMobileImage = styled.div`
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  @media ${({ theme }) => theme.tabletL} {
    display: none;
  }
`;
